import { Form, Row, Col, Button, Modal } from 'react-bootstrap';
import { ActionFunctionArgs, redirect, useLoaderData, useNavigate, useSubmit } from 'react-router-dom';
import styled from 'styled-components';
import { Condition } from '../types';
import { fetchAssetById, registerAssetReturn } from '../api';
import { Field, Formik, Form as FormikForm } from 'formik';
import { object, string } from 'yup';
import { get, startCase } from 'lodash';
import { Asset } from './assets';


const StyledOption = styled.option``;
const StyledButton = styled(Button)`
  background-color: #3498db;
  border-color: #3498db;
  color: #fff;
`;

export async function registerAssetReturnAction({ request }: ActionFunctionArgs) {
  const { assetId, values } = await request.json();
  await registerAssetReturn(assetId, values);

  return redirect(`/assets`);
}

export async function registerAssetReturnLoader({ params }: any) {
  const asset = await fetchAssetById(get(params, 'assetId'));
  return { asset };
}

const mappedConditionOptions = Object.values(Condition).map((condition, index) => {
  const option = ({ value: condition, label: startCase(condition) });
  return (<StyledOption key={index} value={option.value}>{option.label}</StyledOption>);
});

const initialValues = {
  condition: ''
};

const validationSchema = object({
  condition: string().required('Condition is required')
});

function RegisterAssetReturn() {
  const { asset } = useLoaderData() as { asset: Asset };
  const navigate = useNavigate();
  const submit = useSubmit();

  const handleClose = () => navigate(-1);

  const handleSubmit = (values: any) => {
    submit({ values, assetId: asset.id }, { method: "patch", encType: 'application/json' });
  };

  return (
    <Modal
      show={true}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
        {({ touched, errors }) => (
          <Form as={FormikForm} noValidate>
            <Modal.Header closeButton>
              <Modal.Title>Register Asset Return</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group as={Row} className="mb-3" controlId="condition">
                <Form.Label column sm="4">
                  Condition:
                </Form.Label>
                <Col sm="8">
                  <Field
                    as={Form.Select}
                    name='condition'
                    isInvalid={touched.condition && !!errors.condition}
                  >
                    <StyledOption></StyledOption>
                    {mappedConditionOptions}
                  </Field>
                  <Form.Control.Feedback type='invalid'>{errors.condition}</Form.Control.Feedback>
                </Col>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="light" onClick={handleClose}>
                Close
              </Button>
              <StyledButton type='submit'>Submit</StyledButton>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export default RegisterAssetReturn;
